<template>
  <nav class="topbar uk-navbar-container uk-navbar-transparent" :class="`${$store.getters['account/type']}-nav`" uk-navbar data-cy="topbar">
    <div class="uk-navbar-left" data-cy="topbar-left">
      <div class="uk-navbar-item">
        <div class="logo">
          <img src="@/assets/img/logo-icon.png" :alt="`${$globals.app.name.short} - ${$globals.app.name.long} Logo`">
        </div>
      </div>

      <navigation type="top" />
    </div>

    <div class="uk-navbar-right" data-cy="topbar-right">
      <div v-if="$store.getters['account/type'] === 'operator'" class="uk-navbar-item uk-light">
        <div class="uk-button uk-button-primary icon-button" uk-tooltip="Book Appointment" data-cy="btn-book-appointment" @click="newAppointment">
          <div class="icon gg-calendar-today" />
        </div>
      </div>

      <div v-if="$store.getters['account/type'] === 'operator'" class="uk-navbar-item uk-light">
        <router-link tag="div" :to="{ name: 'enquiry-create' }" class="uk-button uk-button-primary icon-button" uk-tooltip="New Enquiry">
          <div class="icon gg-file-document" />
        </router-link>
      </div>

      <div v-if="$store.getters['account/type'] === 'dentist'" class="uk-navbar-item uk-light">
        <div class="uk-inline">
          <button class="uk-button uk-button-primary icon-button" uk-tooltip="Notifications">
            <div class="icon gg-bell" style="margin-top: -4px;" />
          </button>
          <div id="notifications-dropdown" class="uk-padding-remove notifications" uk-dropdown="mode: click; pos: bottom-justify; offset: 30; delay-hide: 0;">
            <template v-if="notifications.count">
              <div class="messages">
                <div v-if="notifications.messages.appointments.length" class="appointments">
                  <div class="title">
                    <div class="uk-text-bold">{{ notifications.messages.appointments.length }} new appointments</div>
                    <div>
                      <div class="uk-button uk-button-primary uk-button-tiny" @click="notificationShowAppointment('all')">View All</div>
                    </div>
                  </div>
                  <div class="appointment-list">
                    <div v-for="(appointment, index) in notifications.messages.appointments" :key="index" class="appointment" @click="notificationShowAppointment(appointment.id)">
                      <div class="uk-text-bold">{{ appointment.customer.name.first }} {{ appointment.customer.name.last }}</div>
                      <div>{{ formatDate(appointment.dentist.data[$store.state.account.profile.dentist]) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="uk-padding-small uk-text-center">
                There are no new notifications at the moment.
              </div>
            </template>
          </div>
          <div v-if="notifications.count" class="count">{{ notifications.count }}</div>
        </div>
      </div>

      <div class="uk-navbar-item">
        <router-link tag="div" :to="{ name: 'profile' }" class="uk-button uk-button-secondary icon-button" uk-tooltip="Your Profile">
          <div class="icon gg-user" />
        </router-link>
      </div>

      <div class="uk-navbar-item">
        <button class="uk-button uk-button-danger icon-button" uk-tooltip="Logout" data-cy="topbar-logout" @click="logout">
          <div class="icon gg-log-off" />
        </button>
      </div>

      <div class="uk-navbar-item uk-light nav-button">
        <button class="uk-button uk-button-primary icon-button" type="button" uk-toggle="target: #offcanvas-nav" uk-tooltip="Menu">
          <div class="icon gg-menu" />
        </button>

        <div id="offcanvas-nav" uk-offcanvas="flip: true; overlay: true" @click="sideNavClick">
          <div class="uk-offcanvas-bar uk-flex uk-flex-column">
            <button class="uk-offcanvas-close" type="button" uk-close />
            <navigation type="side" />
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  name: 'ComponentTopbar',

  components: { Navigation },

  computed: {
    notifications() {
      const response = {
        count: 0,
        messages: {
          appointments: []
        }
      }

      if (this.$store.getters['account/type'] === 'dentist') {
        const appointments = this.$store.getters['appointments/new']
        response.count = appointments.length
        response.messages.appointments = appointments
      }

      return response
    }
  },

  methods: {
    sideNavClick(event) {
      if (event.target.classList.contains('side-nav-link')) {
        this.$uikit.offcanvas('#offcanvas-nav').hide()
      }
    },

    logout() {
      const modal = this.$uikit.modal.confirm('Do you want to log out?')
      modal.dialog.$el.querySelector('.uk-button-primary').setAttribute('data-cy', 'btn-logout-confirm')

      modal.then(() => {
        this.$store.commit('setLoading', true)
        setTimeout(() => { this.$firebase.auth().signOut() }, 250)
      }, () => {
        console.log('Logout Rejected.')
      })
    },

    formatDate(date) {
      const timestamp = `${date.date} ${this.$helpers.timeBits.find((bit) => bit.id === date.bit).time.short}`
      return this.$moment(timestamp, 'YYMMDD HH:mm').fromNow()
    },

    notificationShowAppointment(id) {
      this.$uikit.dropdown('#notifications-dropdown').hide()

      if (id === 'all') {
        this.$router.push({ name: 'appointment-list' })
      } else {
        this.$router.push({ name: 'appointment-single', params: { id } })
      }
    },

    newAppointment() {
      if (this.$route.name === 'appointment-create') {
        this.$uikit.modal.confirm('<div class="uk-text-center">Do you wish to restart the appointment booking process?<br><b>Some of the captured data might be lost!</b></div>').then(() => {
          this.$bus.$emit('appointment-restart')
        })
      } else {
        this.$router.push({ name: 'appointment-create' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.topbar {
  z-index: $global-z-index - 50;
  background: #00819F;
  background: linear-gradient(to left, $colour-primary-dark, $colour-primary);
  box-shadow: $box-shadow;

  .uk-navbar-left,
  .uk-navbar-right {
    flex-wrap: nowrap;
  }

  .logo {
    box-sizing: border-box;
    width: 50px;
    height: 50px;
    padding: 8px;
    background-color: $colour-light;
    text-align: center;

    img {
      width: auto;
      height: 100%;
    }
  }

  .count {
    display: flex;
    position: absolute;
    right: -10px;
    bottom: -10px;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: $colour-danger;
    color: $colour-light;
  }

  .notifications {
    min-width: 300px;

    .appointments {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px solid $colour-grey;
        background-color: $colour-primary;
        color: $colour-light;
      }

      .appointment-list {
        max-height: calc(100vh - 180px);
        overflow: auto;

        .appointment {
          display: flex;
          justify-content: space-between;
          padding: 8px 20px;
          transition: background-color 200ms ease;
          border-bottom: 1px solid $colour-grey;
          background: $colour-light;
          cursor: pointer;

          &:hover {
            background-color: $colour-primary-light;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .uk-navbar-right .uk-navbar-item {
    padding-left: 0;
  }
}
</style>
